import type React from 'react';

import { TextOverflow } from '../../../../../../components/TextOverflow';
import type { Company } from '../../../../../../domain/company';
import type { SignalType, TechnologySignal as TechnologySignalType } from '../../../../../../domain/signal';
import { signalService } from '../../../../../../services/signal/signal';
import { SignalHeader } from '../../SignalHeader';
import { StyledSignalItem, StyledSignalTitleContainer, StyledTooltipContentWrapper } from '../../styles';
import { HighlightedText } from '../HighlightedText/HighlightedText';

type Props = {
  signal: TechnologySignalType;
  company: Company;
};

export const TechnologySignal: React.FC<Props> = ({ signal, company }) => {
  const title = signalService.getTechnologySignalEventText(signal, company.name ?? company.domain);
  const technologiesListText = signalService.getTechnologiesListText(signal.technologies);

  const getTooltipContent = () => {
    return (
      <StyledTooltipContentWrapper>
        {signal.technologies.map((technology) => (
          <div key={technology}>{technology}</div>
        ))}
      </StyledTooltipContentWrapper>
    );
  };

  const isMultipleTechnologies = signal.technologies.length > 1;

  return (
    <StyledSignalItem>
      <SignalHeader type={signal.type as SignalType} eventHappenedDaysAgo={signal.eventHappenedDaysAgo} />
      <StyledSignalTitleContainer tooltipMaxWidth={isMultipleTechnologies ? '70%' : '98%'}>
        {isMultipleTechnologies ? (
          <>
            <TextOverflow text={title} />
            <HighlightedText text={technologiesListText} tooltipContent={getTooltipContent()} minWidth={50} />
          </>
        ) : (
          <TextOverflow text={`${title} ${technologiesListText}`} />
        )}
      </StyledSignalTitleContainer>
    </StyledSignalItem>
  );
};
